import { Component, OnInit,Inject, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';

import {NgbModal, NgbModalConfig, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { isPlatformBrowser, isPlatformServer } from
  '@angular/common';
  import { AuthService } from '../../../../core/services';

declare var $: any;

@Component({
  selector: 'app-admin-sidebar',
  templateUrl: './admin-sidebar.component.html',
  styleUrls: ['./admin-sidebar.component.css']
})
export class AdminSidebarComponent implements OnInit {
  userRole:any;

  

  constructor(private fb: FormBuilder,
    private router: Router,
    private authSvc: AuthService,
    private modalService: NgbModal,@Inject(PLATFORM_ID) private platform: Object
    ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platform)) {
      // var userRoles: any = JSON.parse(sessionStorage.getItem('USER') || '{}');
      const currentUser = JSON.parse(sessionStorage.getItem('USER'));
      this.userRole = currentUser.user.role_id;
    }
    // this.getUserList();
    if (isPlatformBrowser(this.platform)) {
      // $(document).ready(function () {
      //   $('.dropdown-custom .dropdown-toggle').click(function () {
      //     //console.log("on click")
      //     $('.dropdown-custom .dropdown-menu').toggleClass('show');
      //   });
       
      // });
      $(document).ready(function () {
        $('#notifications .dropdown-toggle').click(function () {
          // //console.log("on click 1")
          $('#notifications .dropdown-menu').toggleClass('show');
        });
        $('#settings .dropdown-toggle').click(function () {
          // //console.log("on click")
          $('#settings .dropdown-menu').toggleClass('show');
        });
        $('#reports .dropdown-toggle').click(function () {
          // //console.log("on click")
          $('#reports .dropdown-menu').toggleClass('show');
        });
      });
    
    }
  }

  logout() {
    this.authSvc.logout();
    this.router.navigate(['/admin']);
  }

  userlist(content:any){
    this.modalService.open(content);
  }

  
}
